// INTEL CONFIDENTIAL
// Copyright (C) 2023 Intel Corporation

import React from 'react'
import './GaudiAiSection.scss'

interface GaudiAiSectionItemProps {
  title: string
  children: React.ReactNode
}

const GaudiAiSectionItem: React.FC<GaudiAiSectionItemProps> = ({ title, children }): JSX.Element => {
  return (
    <div className="cinema-content-item-container gap-s4">
      <h3 className="h4 text-white">{title}</h3>
      {children}
    </div>
  )
}

const GaudiAiSection: React.FC = (): JSX.Element => {
  const devResourcesURL = 'https://www.intel.com/content/www/us/en/software/ai-accelerators/gaudi-software.html'
  const huggingFaceURL = 'https://www.intel.com/content/www/us/en/developer/ecosystem/hugging-face.html'

  return (
    <div className="cinema-container px-s8 py-s9 px-sm-s10 py-sm-s12">
      <div className="internal-container gap-s8">
        <h2>
          <span className="display-6 text-white">Introducing Gaudi AI processor supercomputer</span>
        </h2>
        <div className="cinema-content-container gap-s8">
          <div className="cinema-content-items-container py-s6 gap-s6 d-none d-sm-flex">
            <GaudiAiSectionItem title="Optimized for developers">
              <span>
                Take advantage of{' '}
                <a className="link text-white" href={devResourcesURL} target="_blank" rel="noreferrer">
                  software tools and developer resources
                </a>{' '}
                to get up to speed quickly.
              </span>
            </GaudiAiSectionItem>
            <GaudiAiSectionItem title="Support for new and existing models">
              <span>
                Customize reference models, start fresh, or migrate existing models using open-source tools, including
                resources from{' '}
                <a className="link text-white" href={huggingFaceURL} target="_blank" rel="noreferrer">
                  Hugging Face
                </a>
                .
              </span>
            </GaudiAiSectionItem>
            <GaudiAiSectionItem title="Integrated with PyTorch">
              Keep working with the library your team already knows.
            </GaudiAiSectionItem>
            <GaudiAiSectionItem title="Easy migration of GPU-based models">
              Quickly port your existing solutions using our purpose-built software tools.
            </GaudiAiSectionItem>
          </div>
          <video
            preload="metadata"
            className="gaudi-video"
            controls={true}
            muted={true}
            id="gaudi-3-video"
            poster="/images/videoNotPlay.svg"
            aria-label="Intel tiber ai cloud features gaudi super computer cluster"
          >
            <source
              src={'../images/Intel_Gaudi_Tiber Update_20241126.mp4'}
              type="video/mp4"
              media="(min-width: 768px)"
            />
            <source
              src={'../images/Intel_Gaudi_Tiber Update_20241126_low.mp4'}
              type="video/mp4"
              media="(max-width: 767px)"
            />
            Gaudi 2 video
          </video>
        </div>
      </div>
    </div>
  )
}

export default GaudiAiSection
